<div class="form-step">
  <h3>{{ name | transloco }}</h3>
  <ng-content></ng-content>
</div>
